import type { PageErrorProps } from "./page-error.type";

import { Button, Result } from "antd";
import { Trans, useTranslation } from "react-i18next";

import { HelpCenterLink } from "@/modules/help-center";
import { StaticRouteLink } from "@/modules/static-route";

import { getPageErrorKey, getPageErrorImageName } from "./page-error.helper";

import "./page-error.style.less";

export const PageError = ({
  status,
  isAuth,
  isContextIssue,
  customContext,
}: PageErrorProps) => {
  const { t } = useTranslation();

  const errorKey = getPageErrorKey({ status, isContextIssue });
  const translationBase = `navigation:pageError:${errorKey}`;

  const imageName = getPageErrorImageName(errorKey);
  const imagePath = `/images/page-error/${imageName}`;

  return (
    <Result
      title={t(`${translationBase}.title`)}
      subTitle={
        <Trans
          i18nKey={`${translationBase}.description`}
          components={{ HelpLink: <HelpCenterLink /> }}
        />
      }
      icon={isAuth ? null : <img src={imagePath} />}
      extra={
        isAuth ? (
          <StaticRouteLink route="login">
            <Button type="primary">
              {t("navigation:pageError:returnToLogin")}
            </Button>
          </StaticRouteLink>
        ) : (
          <StaticRouteLink route="dashboard" customContext={customContext}>
            <Button>{t("navigation:pageError:returnToDashboard")}</Button>
          </StaticRouteLink>
        )
      }
      classNames={{
        root: "page-error",
        subTitle: "page-error-description",
        extra: "page-error-actions",
      }}
    />
  );
};
